(ns renolit-roofing-service.layout.menu
  (:require [reagent.core :as r]))

(defonce menu-state
  (r/atom {:visible false :x 0 :y 0 :content nil :target-el nil}))

(defn- hide-menu!
  []
  (reset! menu-state {:visible false :x 0 :y 0 :content nil}))

(defn toggle-menu!
  [el opts content]
  (let [{:keys [visible]} @menu-state]
    (if visible
      (hide-menu!)
      (let [rect (.getBoundingClientRect el)
            [x y] (case (:placement opts)
                    "bottom"
                    [(- (.-left rect) (.-width rect))
                     (+ (.-top rect) (.-height rect))]

                    [(- (.-left rect) (.-width rect))
                     (+ (.-top rect) (.-height rect))])]
        (reset! menu-state {:visible true
                            :x x
                            :y y
                            :content content
                            :target-el el})))))

(defn menu-portal
  []
  (let [{:keys [visible x y content]} @menu-state]
    (when visible
      [:div.tooltip
       {:style {:top y
                :left x}}
       content])))

(defn menu-portal-wrapper []
  [menu-portal])

(defn setup-resize-listener! []
  (.addEventListener js/window "resize"
                     (fn []
                       (let [{:keys [visible target-el]} @menu-state]
                         (when (and visible target-el)
                           (let [rect (.getBoundingClientRect target-el)
                                 [x y] [(- (.-left rect) (.-width rect))
                                        (+ (.-top rect) (.-height rect))]]
                             (swap! menu-state assoc :x x :y y)))))))

(defn setup-global-click-listener! []
  (.addEventListener js/document "click"
                     (fn [_]
                       (when (:visible @menu-state)
                         (hide-menu!)))))
